// Utility function to strip HTML tags and trim whitespace

export const stripHtmlAndTrim = (str = '') => {
  if (!str) return '';
  return str
    .replace(/<[^>]*>/g, '')
    .trim();
};
